import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as transactionsMainReducer from '../employee-detail.reducer';
import * as transactionsAllReducer from '../reducers/transactions-all.reducer';

export const selectTransactionsAll = createSelector(
  transactionsMainReducer.transactionsAllState,
  transactionsAllReducer.getTransactionsAll
);
